import Moment from 'moment';
import React, { Component } from 'react';
import {
  Button, Cell,
  Checkbox,
  DataTable, Divider, Grid,



  TableBody,

  TableColumn,
  TableHeader,
  TablePagination, TableRow,
  Chip,SelectField,
  SelectionControl
} from 'react-md';
import ApiRequestService from '../component/ApiRequestService';
import CollapsableColumn from '../component/CollapsableColumn';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import { AppProperties } from '../common/function';
import '../css/QuizListWidget.css';
import { FontIcon } from 'react-md';
import editIcon from '../images/png/edit.png';
import copyIcon from '../images/png/copy.png';
import viewRawData from '../images/png/viewRawData.png'

import { getUtcTimestamp } from '../common/function';
import ReactTooltip from 'react-tooltip';
import { NotificationManager } from 'react-notifications';
import ViewRawDataModal from './ViewRawDataModal';


const quizDataDummy = [
  {
    quiz_id: 523,
    quiz_name: 'create new assignment 101',
    start_date: '27/02/2018',
    start_time: '00:00:00',
    end_date: '27/02/2018',
    end_time: '00:00:00',
    quiz_type: 1,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 7,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 1,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 528,
    quiz_name: 'check order 3',
    start_date: '08/03/2018',
    start_time: '00:00:00',
    end_date: '12/03/2018',
    end_time: '00:00:00',
    quiz_type: 0,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 78,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 529,
    quiz_name: 'order 4',
    start_date: '08/03/2018',
    start_time: '19:56:00',
    end_date: '22/03/2018',
    end_time: '19:57:00',
    quiz_type: 1,
    mastery_condition: 6,
    mastery_units: 8,
    maximum_attempted: 9,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 532,
    quiz_name: 'test 1',
    start_date: '08/03/2018',
    start_time: '20:10:00',
    end_date: '11/03/2018',
    end_time: '20:10:00',
    quiz_type: 1,
    mastery_condition: 4,
    mastery_units: 5,
    maximum_attempted: 6,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 533,
    quiz_name: 'test 2',
    start_date: '08/03/2018',
    start_time: '20:16:00',
    end_date: '15/03/2018',
    end_time: '20:16:00',
    quiz_type: 1,
    mastery_condition: 6,
    mastery_units: 7,
    maximum_attempted: 8,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 534,
    quiz_name: 'test 3',
    start_date: '08/03/2018',
    start_time: '00:00:00',
    end_date: '22/03/2018',
    end_time: '00:00:00',
    quiz_type: 0,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 7,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '0',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 535,
    quiz_name: 'test timer',
    start_date: '12/03/2018',
    start_time: '00:00:00',
    end_date: '19/03/2018',
    end_time: '00:00:00',
    quiz_type: 2,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 7,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 1,
    test_time: '30',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 536,
    quiz_name: 'timer test 1',
    start_date: '12/03/2018',
    start_time: '00:00:00',
    end_date: '19/03/2018',
    end_time: '00:00:00',
    quiz_type: 2,
    mastery_condition: 5,
    mastery_units: 6,
    maximum_attempted: 7,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 1,
    test_time: '30',
    randomize_categories: 2,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  },
  {
    quiz_id: 539,
    quiz_name: 'random',
    start_date: '12/03/2018',
    start_time: '00:00:00',
    end_date: '12/03/2018',
    end_time: '00:00:00',
    quiz_type: 0,
    mastery_condition: 6,
    mastery_units: 7,
    maximum_attempted: 8,
    semester_id: 1,
    course_id: 8,
    section_Id: 16,
    is_test: 0,
    test_time: '',
    randomize_categories: 1,
    quiz_details: null,
    quiz_subcat_info: null,
    quiz_delete_arr: null
  }
];
const quizListMap = function(quiz_data) {
  var condensedList = {};
  let tempSectionId = 0 ;

  if (quiz_data.length > 0) {
    quiz_data.forEach(element => {
      if (
        condensedList[element.quiz_id] === undefined ||
        condensedList[element.quiz_id] === null
      ) {
  
        condensedList[element.quiz_id] = element;
        let sectionName = element.section_name;
        condensedList[element.quiz_id].section_name = [];
        tempSectionId = element.section_Id;
        if(element.enable_subsection){
          let subsection_name = sectionName +' ( '+ element.subsection_name + ' )'
          condensedList[element.quiz_id].section_name.push(subsection_name);
        }else{
          condensedList[element.quiz_id].section_name.push(sectionName);
        }
        condensedList[element.quiz_id].title = element.quiz_name;
        condensedList[element.quiz_id].quiz_id = element.quiz_id;
        condensedList[element.quiz_id].key = element.id;
      } else {
        if(element.enable_subsection){
          
          if(element.section_Id === tempSectionId){
            let TempSection = condensedList[element.quiz_id].section_name
            let finalSection = TempSection[TempSection.length - 1].replace(' )', ', ' + element.subsection_name + ' )' );
          
           condensedList[element.quiz_id].section_name[TempSection.length - 1] = finalSection; 
          } else{
            tempSectionId = element.section_Id;
            let subsection_name = element.section_name +' ( '+ element.subsection_name + ' )'
                condensedList[element.quiz_id].section_name.push(subsection_name);
          }
        }else{

          condensedList[element.quiz_id].section_name.push(element.section_name);
        }
      }
    });
  }

  var condensedArray = Object.keys(condensedList).map(function(key) {
    //console.log('element 111',  condensedArray , 'condensedList[key]', condensedList)
    return condensedList[key];
  });
  return condensedArray;
};

const chipStyles = {
    selected : {backgroundColor:'#bb0000',marginLeft:"5px"},
    default : {backgroundColor:'white',marginLeft:"5px",border:'solid 1px #576271'},
    labelSelected:{color:"white",fontSize:'10px'},
    labelDefault:{color:"#576271",fontSize:'10px'},
    cancelIcon:{color:"#fff"}
};

export default class QuizListWidgetCourses extends Component {
  appProperties = AppProperties();
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      course_name: '',
      section_name: '',
      quiz_data: [], // copy of quiz_data -> filteredQuizData
      filteredQuizData:[],// filteredQuizData -> slicedData
      slicedData: [],
      loadingNumberOfCompletedStudent : true,
      NumberOfCompletedStudent : {},
      sortingOrder: 'ascending',
      sortBy: '',
      page: 1,
      allCheckBoxStatus:{},
      addCheckBoxIndex:{},
      currentFilter:null, // 'Closed' or 'Current' or 'Upcoming'
      showViewRawDataModal: false,
      assignmentData: null,
    };
  }

  returnQuizStatus = (startDate,endDate,startTime,endTime)=>{
    var startUtc = getUtcTimestamp(startDate,startTime);
    var endUtc = getUtcTimestamp(endDate,endTime);
    var now    = new Date().getTime();

    if(now < startUtc){
      return 'Upcoming'
    }
    if(now > endUtc){
      return 'Closed'
    }
    return 'Current'
  };

  setFilter = (filter)=>{
    var filteredData;

    if(filter === null){
      filteredData = [...this.state.quiz_data];
    } else {
        filteredData = this.state.quiz_data.filter((rowData,index)=>{
          return (this.returnQuizStatus(rowData.start_date,rowData.end_date,rowData.start_time,rowData.end_time) === filter);
        });
    }

    this.setState({
      ...this.state,
      currentFilter : filter,
      filteredQuizData:filteredData,
      slicedData: filteredData.slice(0,this.props.rowsPerPage)
    });

  };

  getQuizData(req_course_id, req_section_id) {
    const payload = {
      course_id: parseInt(req_course_id, 10)
    };

    return new Promise(function(resolve, reject) {
      ApiRequestService({
        method: 'post',
        //url: 'http://localhost:8095/getAllQuiz',
        url: '/getAllQuiz',
        data: payload
      })
        .then(res => {
          if (res.data !== undefined && res.data !== null && 
            res.data.data !== undefined && res.data.data !== null && 
            res.data.data.quizes_list !== undefined &&
            res.data.data.quizes_list !== null &&
            res.data.data.quizes_list.length > 0
          ) {
            return resolve(res.data.data.quizes_list);
          } else {
            console.error('Quiz Data Empty');
            let emptyArray = [];
            return resolve(emptyArray);
          }
        })
        .catch(error => {
          console.error('Error When Retriving Quiz Details ', error);
          reject(error, null);
        });
    });
  }

  getNumberOfStudentsCompletedData(req_course_id) {
    const payload = {
      course_id: parseInt(req_course_id, 10),
      section_id: 0
    };

    return new Promise(function(resolve, reject) {
      ApiRequestService({
        method: 'post',
        //url: 'http://localhost:8095/getAllQuiz',
        url: '/getQuizStudentsCompleted',
        data: payload
      }).then(res => {
          if (res.data !== undefined && res.data !== null && 
            res.data.data !== undefined && res.data.data !== null 
          ) {
            return resolve(res.data.data);
          } else {
            console.error('Empty Data');
            return resolve({});
          }
        }).catch(error => {
          console.error('Error When Retriving Quiz Details ', error);
          return resolve({});
        });
    });
  }

  handleUpdateAssignmentStatus = (rowData, index) => {
    let payload = {
      quiz_id: rowData.quiz_id,
      status: rowData.status === 0 ? 1 : 0,
    }
    console.debug("payload>>>>>", payload)

    const response = ApiRequestService({
      method: 'POST',
      url: '/updateAssignmentStatus',
      data: payload
    })

    response.then(res => {
      console.debug("res", res)
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
        if (res.data.data != null) {
          let newSlicedData = this.state.slicedData;
          newSlicedData[index].status = payload.status;
          console.debug("newSlicedData>>>>", newSlicedData)
          this.setState({
            slicedData: [...newSlicedData],
          })
        }
      }
    })

  }

  handleSelects = (select,index=null,quiz_id=null)=>{
    var page = this.state.page;
    var assignment = (index === null) ? [...this.state.slicedData] : this.state.slicedData[index];
    this.props.assignmentSelectHandle(assignment,select,(index === null),page);

    // Handling Checkbox value
    var newAddBox = {...this.state.addCheckBoxIndex};
    if(newAddBox[page] === undefined){
      newAddBox[page] = {};
    }
    // Check or Uncheck Table head checkBox
    if(index === null){
      this.state.slicedData.forEach((item,i)=>{
          newAddBox[page][item.quiz_id] = select;
      });

      this.setState( {
        ...this.state,
        allCheckBoxStatus : {
          ...this.state.allCheckBoxStatus,
          [page] : select
        },
        addCheckBoxIndex : newAddBox
      });
    }
    // Adding or Removing individual checkBox
    else{
      if(select){
        newAddBox[page][quiz_id] = select;
        this.setState( {
          ...this.state,
          addCheckBoxIndex : newAddBox
        });
      }
      else{
        var checkBoxStatus = (Object.keys(newAddBox[page]).length <= 1) ? false : this.state.allCheckBoxStatus[page];
        delete newAddBox[page][quiz_id];
        this.setState( {
          ...this.state,
          allCheckBoxStatus : {
            ...this.state.allCheckBoxStatus,
            [page] : checkBoxStatus
          },
          addCheckBoxIndex : newAddBox
        });
      }
    }
  };

  unSelectAllCheckbox = ()=>{
    this.props.removeAllSelectedAssignment();
    this.setState( {
      ...this.state,
      allCheckBoxStatus : {},
      addCheckBoxIndex : {}
    });
  };

  handlePagination = (start, rowsPerPage,currentPage) => {
    this.setState({
      slicedData: this.state.filteredQuizData.slice(start, start + rowsPerPage),
      page: currentPage,
    });
  };

  generateRawDataUrl = (rawData) => {
    let url = `${window.location.origin}/${rawData.quiz_type === 1 ? "testScore" : "quizScore"}?qname=${rawData.quiz_name}&quiz_id=${rawData.quiz_id}&course_id=${rawData.course_id}&static=0&course_name=${this.props.selectedCourse.course_name}&course_indx=${this.props.selectedCourseIndex}&is_anonymous=${rawData.is_anonymous}`;
    return url;
  }

  componentWillMount() {
    if (this.props.testMode) {
      //Load Dummy Data
      this.setState({
        loading: false,
        course_id: 8,
        course_name: 'course test 102',
        section_id: 16,
        section_name: 'add section 101',
        quiz_data: quizDataDummy,
        slicedData: quizDataDummy.slice(0, this.props.rowsPerPage)
      });
    } else {
      console.debug('this.props.course_id', this.props.course_id);
      let promiseVal = this.getQuizData(this.props.course_id);
      let promiseNumberOfStdComp = this.getNumberOfStudentsCompletedData(this.props.course_id)

      promiseNumberOfStdComp.then(data=>{
        this.setState({
          loadingNumberOfCompletedStudent : false,
          NumberOfCompletedStudent : {...data}
        })
      })

      promiseVal.then(quizData => {
        let condensedArray  = quizListMap(quizData);
        this.props.onQuizListChanged(condensedArray);
        if(condensedArray !== undefined && condensedArray !== null &&condensedArray.length > 0){
          condensedArray  = condensedArray.reverse();
        }

        this.setState({
          quiz_data: condensedArray,
          filteredQuizData:condensedArray,
          slicedData: condensedArray.slice(0, this.props.rowsPerPage),
          loading: false
        });
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    console.debug('this.props.course_id' + this.props.course_id);
    console.debug('nextProps.course_id' + nextProps.course_id);

    if (nextProps.course_id !== this.props.course_id) {
      this.setState({
        loadingNumberOfCompletedStudent : true,
        loading: true 
      });
      this.getQuizData(nextProps.course_id).then(quizData => {
        
        var condensedArray = quizListMap(quizData);
        this.props.onQuizListChanged(condensedArray);
        //bug id 334 fixes
        condensedArray = condensedArray.reverse();
      
        this.setState({
          quiz_data: condensedArray,
          filteredQuizData: condensedArray,
          slicedData: condensedArray.slice(0, nextProps.rowsPerPage),
          loading: false
        });
      });
      
      this.getNumberOfStudentsCompletedData(nextProps.course_id).then(data=>{
        this.setState({
          loadingNumberOfCompletedStudent : false,
          NumberOfCompletedStudent : {...data}
        })
      })

      this.setState({
        sortingOrder:"ascending",
        sortBy: '',
        page: 1,
      })
    }
  }
  onScoreButtonClick = event => {
    let quizObject = JSON.parse(event._targetInst._currentElement.props.id);
    this.props.onScoreClick(quizObject);
  };

  onQuizEditClick = event => {
    let quizObject = JSON.parse(event._targetInst._currentElement.props.id);
    this.props.onQuizEditClick(quizObject);
  };

  sort(columnName) {
    let data = this.state.quiz_data

    if (this.state.sortingOrder === "descending") {
      data.sort((a, b) => {
        if (a[columnName] < b[columnName]) {return 1}
        if (a[columnName] > b[columnName]) {return -1}
        return 0
      })  
    } else {
      data.sort((a, b) => {
        if (a[columnName] < b[columnName]) {return - 1}
        if (a[columnName] > b[columnName]) {return 1}
        return 0
      })
    }

    this.setState({
      quiz_data: data,
      slicedData: data.slice((this.state.page -1) * this.props.rowsPerPage, this.state.page * this.props.rowsPerPage),
      sortBy: columnName,
      sortingOrder: this.state.sortingOrder === 'ascending' ? 'descending' : 'ascending',
    })
  }

  render() {
    if (this.state.loading) return <LoadingSpinner loading={true} />;

    const { slicedData, quiz_data,page } = this.state;
    const rows = quiz_data.length;
   // const slicedDataReversed = slicedData.reverse();
    return (
      <Grid gutter={2} spacing={1}>
        <Cell size={12}>
          <Grid
            gutter={3}
            className=" noMarigin styleScoreDistribution noHorizondalPadding noTopPadding"
          >
            <Cell size={12} phoneSize={12} className="noLineHeight">
              <p style={{fontSize:"medium"}}>
                <div style={{display:'flex',float:'left',fontWeight:'bold'}}>
                  Assignment List &nbsp;
                  <div>({this.state.quiz_data.length})</div>
                </div>
                <br/>
                <Button
                          id={"copy"}
                          className="StyleButtonDashboard "
                          flat
                          onClick={() => this.props.onCopyAllQuizClick(this.props.course_id)}
                          style={{float:'right', fontSize:'13px'}}
                        >
                          Import Assignments from previous Semester
                </Button>
              </p>
            </Cell>
            <Cell size={12} phoneSize={12}>
            <span className="quizSubText" style={{lineHeight:'1'}}>
            <div style={{display:'flex',float:'left',alignItems:'center'}}>
                      <Chip label="Clear all" 
                        style={(Object.keys(this.props.selectedAssignmentList).length > 0)?  chipStyles.selected:chipStyles.default} 
                        labelStyle={(Object.keys(this.props.selectedAssignmentList).length > 0)?  chipStyles.labelSelected:chipStyles.labelDefault}
                         onClick={()=>{
                          if(Object.keys(this.props.selectedAssignmentList).length > 0){
                            this.unSelectAllCheckbox();
                        }}}/>
              </div>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <div style={{display:'flex',float:'right', fontSize:'13px',marginRight:"5px",alignItems:'center'}}>
                <SelectField
                        placeholder={(Object.keys(this.props.selectedAssignmentList).length) ? "DOWNLOAD SELECTED RAW DATA" : "BULK DATA DOWNLOAD"}
                        itemLabel="title"
                        menuItems={(Object.keys(this.props.selectedAssignmentList).length) ? this.props.downloadListArray : this.props.downloadAllListArray}
                        onChange={(e,index)=>{
                          if(Object.keys(this.props.selectedAssignmentList).length <= 0){
                            this.props.createConsolidatedReport(e,index,this.state.quiz_data);
                          }
                          else{
                            this.props.createConsolidatedReport(e,index);
                          }
                        }}
                />
                <Button className='nocqcStyle' icon data-tip data-for='download-all-raw-data'>help</Button>
                <ReactTooltip id='download-all-raw-data' type='light' className='tool-tip' place="bottom">
                  <span>{this.props.helpTextModel.getHelpTextForKey('Download all raw data')}</span>
                </ReactTooltip>
                </div>
              {/* <div>{this.appProperties.schoolMode?"Current Academic Year":"Current Semester"}</div> */}
              <div>&nbsp;&nbsp;Status : </div>
                     <Chip label="Closed" 
                       style={this.state.currentFilter === 'Closed' ?  chipStyles.selected:chipStyles.default} 
                       labelStyle={this.state.currentFilter === 'Closed' ?  chipStyles.labelSelected:chipStyles.labelDefault}
                       onClick={()=>{
                        if(this.state.currentFilter !== 'Closed'){
                          this.setFilter('Closed');
                        }
                       }}
                       children={
                            <FontIcon style={chipStyles.cancelIcon} onClick={()=>{this.setFilter(null);}}>add_circle</FontIcon>
                       }
                       removable={(this.state.currentFilter === 'Closed')}
                       />
                     <Chip label="Current" 
                       style={this.state.currentFilter === 'Current' ?  chipStyles.selected:chipStyles.default} 
                       labelStyle={this.state.currentFilter === 'Current' ?  chipStyles.labelSelected:chipStyles.labelDefault}
                       onClick={()=>{
                        if(this.state.currentFilter !== 'Current'){
                          this.setFilter('Current');
                        }
                       }}
                       children={
                        <FontIcon style={chipStyles.cancelIcon} onClick={()=>{this.setFilter(null);}}>add_circle</FontIcon>
                     }
                     removable={(this.state.currentFilter === 'Current')}/>
                     <Chip label="Upcoming" 
                       style={this.state.currentFilter === 'Upcoming' ?  chipStyles.selected:chipStyles.default} 
                       labelStyle={this.state.currentFilter === 'Upcoming' ?  chipStyles.labelSelected:chipStyles.labelDefault}
                       onClick={()=>{
                        if(this.state.currentFilter !== 'Upcoming'){
                          this.setFilter('Upcoming');
                        }
                       }}
                       children={
                        <FontIcon style={chipStyles.cancelIcon} onClick={()=>{this.setFilter(null);}}>add_circle</FontIcon>
                       }
                       removable={(this.state.currentFilter === 'Upcoming')}/>
              </span>
            </Cell>
            <Cell size={12} className="noMarigin fullWidth">
              <Divider className="fullWidth" />
            </Cell>
            <Cell size={12} phoneSize={12} className="noMarigin fullWidth">
              <DataTable plain baseId="QuizTablePagination">
                <TableHeader>
                  <TableRow selectable={false}>
                   <TableColumn className="quizTableColumn">
                        <Checkbox id={`checkbox-head`} onChange={(select,event)=>{
                          this.handleSelects(select);
                        }} checked={this.state.allCheckBoxStatus[page] ? true : false}
                        style={{marginTop:'0px'}}/>
                  </TableColumn>
                  <TableColumn onClick={() => this.sort("quiz_id")} className="quizTableHeaderColumn">
                      <div>
                        ID  
                        <FontIcon style={{
                            display: this.state.sortBy === "quiz_id" ? "inline-block" : "none",
                          }} >{this.state.sortingOrder === "ascending" ? "arrow_upward" : "arrow_downward"}
                          </FontIcon>
                      </div>
                
                  </TableColumn>
                    <TableColumn onClick={() => this.sort("quiz_name")} className="quizTableHeaderColumn">
                        <div>
                        Name  
                        <FontIcon style={{
                            display: this.state.sortBy === "quiz_name" ? "inline-block" : "none",
                          }} >{this.state.sortingOrder === "ascending" ? "arrow_upward" : "arrow_downward"}
                          </FontIcon>
                      </div>
                    
                    </TableColumn>
                    <TableColumn className="quizTableHeaderColumn" onClick={() => this.sort("quiz_type")}>
                        <div>
                          Type  
                          <FontIcon style={{
                              display: this.state.sortBy === "quiz_type" ? "inline-block" : "none",
                            }} >{this.state.sortingOrder === "ascending" ? "arrow_upward" : "arrow_downward"}
                            </FontIcon>
                        </div>
                    </TableColumn>
                    <TableColumn className="quizTableHeaderColumn">
                      Sections
                    </TableColumn>
                    <TableColumn className="quizTableHeaderColumn" onClick={() => this.sort("start_date")}>
                      <div>
                          Start Date  
                          <FontIcon style={{
                              display: this.state.sortBy === "start_date" ? "inline-block" : "none",
                            }} >{this.state.sortingOrder === "ascending" ? "arrow_upward" : "arrow_downward"}
                            </FontIcon>
                      </div>

                    </TableColumn>
                    <TableColumn className="quizTableHeaderColumn" onClick={() => this.sort("end_date")}>
                      <div>
                          Due Date  
                          <FontIcon style={{
                              display: this.state.sortBy === "end_date" ? "inline-block" : "none",
                            }} >{this.state.sortingOrder === "ascending" ? "arrow_upward" : "arrow_downward"}
                            </FontIcon>
                      </div>

                    </TableColumn>
                    <TableColumn  style={{textAlign : "center"}}  className="quizTableHeaderColumn" onClick={() => this.sort("number_of_students_completed")}>
                      <div style={{
                          display:"flex",
                          justifyContent:"space-around",
                          alignItems:"center"
                        }}>
                          # Completed  
                          <FontIcon style={{
                              display: this.state.sortBy === "number_of_students_completed" ? "inline-block" : "none",
                            }} >{this.state.sortingOrder === "ascending" ? "arrow_upward" : "arrow_downward"}
                            </FontIcon>
                      </div>
                    </TableColumn>
                    {/* Show the below column only for LTI course */}
                    {this.props.isLTIEnabled ? 
                      <TableColumn style={{textAlign:"center"}}>
                          LTI Assignment Name
                      </TableColumn>
                    : null}
                    <TableColumn className="quizTableHeaderActionColumn" style={{
                      width:"250px "
                    }}>
                      Actions
                    </TableColumn>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {slicedData.map((rowData, index) => (
                    <TableRow selectable={false} key={index}>
                      <TableColumn className="quizTableColumn">
                          <div>
                          <Checkbox id={`checkbox-assignment-row-${index}`}
                          checked={
                            ( this.state.addCheckBoxIndex[page] && this.state.addCheckBoxIndex[page][rowData.quiz_id]) ? this.state.addCheckBoxIndex[page][rowData.quiz_id] : false }
                          onChange={(select,event)=>{
                          this.handleSelects(select,index,rowData.quiz_id);
                            }}/>
                          </div>
                      </TableColumn>
                      <TableColumn className="quizTableColumn">
                        {rowData.quiz_id}
                      </TableColumn>
                      <TableColumn className="quizTableColumn name-col" style={{
                      }}>
                        {rowData.quiz_name}
                      </TableColumn>
                      <TableColumn className="quizTableColumn">
                        {rowData.quiz_type == 1 ? 'Test':'Mastery'}
                      </TableColumn>

                      <CollapsableColumn
                        data={rowData.section_name}
                        className="quizTableColumn"
                        // WidthReduce = {true}
                      >
                        Hello
                      </CollapsableColumn>
                      <TableColumn className="quizTableColumn">

                        {Moment(rowData.start_date,'DD/MM/YYYY').format("MM/DD/YYYY")}
                      </TableColumn>
                      <TableColumn className="quizTableColumn">

                        {Moment(rowData.end_date,'DD/MM/YYYY').format("MM/DD/YYYY")}
                      </TableColumn>
                      <TableColumn style={{textAlign : "center"}} className="quizTableColumn">
                        {this.state.loadingNumberOfCompletedStudent ? <LoadingSpinner loading={true} /> : (this.state.NumberOfCompletedStudent[rowData.quiz_id] || 0)}
                      </TableColumn>
                      
                      {/* Show the below column only for LTI course */}
                      {this.props.isLTIEnabled ? 
                        <TableColumn style={{textAlign:'center'}}>
                          {rowData?.lti_assignment_name}
                        </TableColumn>
                      : null}
                      <TableColumn className="quizTableColumn quizTableHeaderActionColumn" style={{
                        display:'flex',
                        justifyContent:'flex-start',
                        alignItems:'center'
                      }}>
                    
                        <Button
                          icon
                          tooltipLabel="Edit"
                          onClick={() => this.props.onQuizEditClick(rowData)}
                        >
                          <img src={editIcon} alt="Edit"  />
                        </Button>
                        <Button
                          id={"copy"+rowData.quiz_name}
                          icon
                          tooltipLabel="Copy Assignment"
                          onClick={() => this.props.onCopyQuizClick(rowData)}
                        >
                          <img src={copyIcon} alt="Copy Assignment"  />
                        </Button>
                        <Button
                          icon
                          tooltipLabel={`${this.appProperties.eqmMode? "View Result" :"View Raw Data"}`}
                          onClick={() => {
                            this.setState({
                              showViewRawDataModal: true,
                              assignmentData: rowData
                            })
                            // this.props.onScoreClick(rowData)
                          }}
                        >
                       <div><img src={viewRawData} style={{height:'25px',color:'#314f8c'}} alt={`${this.appProperties.eqmMode? "View Result" :"View Raw Data"}`} /></div>
                          
                        </Button>
                        {!this.props.selectedCourse.is_lti_enabled ? 
                          <div>
                            <Button tooltipLabel={`Click to ${rowData.status === 1 ? "Unpublish" : "Publish"}`}>
                            <SelectionControl 
                              className={'assignment-status ' + (rowData.status == 1 ? 'course-status-toggle-on' : 'course-status-toggle-off')}
                              type="switch"
                              name="Status"
                              label={null}
                              checked={rowData.status === 1}
                              onClick={() => {
                                this.handleUpdateAssignmentStatus(rowData, index)
                              }}
                              />
                              </Button>
                          </div>
                        : null}
                        {rowData.is_anonymous && !this.props.selectedCourse.is_lti_enabled ? 
                          <Button
                            icon
                            tooltipLabel="Copy Anonymous Link"
                            tooltipPosition='bottom'
                            onClick={() => {
                              navigator.clipboard.writeText(rowData.anonymous_link)
                              NotificationManager.success("Anonymous Link was copied to your clipboard.", "")
                            }}
                          >
                            <div>
                              <FontIcon style={{fontSize:'2rem'}}>link</FontIcon>
                            </div>
                          </Button>
                        : null}
                       
                      </TableColumn>
                    </TableRow>
                  ))}
                </TableBody>

                <TablePagination
                  className='custom-pagination'
                  rowsPerPageItems={[3, 8, 12, 16, 20]}
                  defaultRowsPerPage={this.props.rowsPerPage}
                  // page={this.state.page}
                  rows={this.state.currentFilter === null ? rows : this.state.filteredQuizData.length}
                  rowsPerPageLabel=""
                  onPagination={this.handlePagination}
                />
              </DataTable>

              <ViewRawDataModal 
                visible={this.state.showViewRawDataModal}
                url= {this.state.showViewRawDataModal ? this.generateRawDataUrl(this.state.assignmentData) : ''}
                handleCloseModal={() => this.setState({showViewRawDataModal: false})}
              />
            </Cell>
          </Grid>
        </Cell>
      </Grid>
    );
  }
}
